import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Col, Form, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { useToast } from 'context/providers/ToastProvider';

import EditarUsuario from './RegistroEmpleado'

const DetalleEmpleado = () => {

    const { id } = useParams();

    const { token, setToken } = useToken();
    const { showErrorToast } = useToast();
    const [cargando, setCargando] = useState(true);
    const [empleado, setEmpleado] = useState({});

    /**
        * Se ejecuta la primera vez
        */
    useEffect(() => {
        informacionDetalladaEmpleado();
    }, []);

    //*
    //* obtiene informacion detallada de el empleado al que se le haga click
    //*
    const informacionDetalladaEmpleado = async () => {


        setCargando(true);

        var objDataSend = {};

        objDataSend.idUsuario = id;

        console.log(objDataSend, 'ID DEL PRODUCTO');
        var jDataSend = JSON.stringify(objDataSend);


        const response = await fetch("/api/usuario/DetalleEmpleado/",
            {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: jDataSend
        })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch: ' + error);
                console.log('Hubo un problema con la peticion Fetch: ' + error.message);
            });

        if (response.ok) {

            console.log("===================== informacionDetalladaEmpleado =========================");

            console.log(response);
            const data = await response.json();

            console.log("===================== RESPONSETYPE =========================", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                var empleado = ObjDetalles.table2[0];

                setEmpleado(empleado);
                setCargando(false)

            } else {
                showErrorToast(data.vMessage);
            }
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setCargando(false);
    };

    return (
        <>
            {
                cargando ?
                <>
                    <Card className="mb-2">
                    <Card.Header className="d-flex align-items-center ">
                        
                        {/* Contenedor central (ocupa espacio restante) */}
                        <div className="d-flex align-items-center justify-content-center flex-grow-1">
                            <img
                                src="/img/team/nofoto50.png"
                                alt="connectCircle"
                                height={40}
                                className="me-2"
                            />
                            
                        </div>
                    </Card.Header>
                </Card>

                <Card>
                    <Card.Body>
                        <Row>
                            <h5>
                                Descripcion de Usuario
                            </h5>

                            <Col md={6} className="mt-2">

                                {/* Campo para subir la foto */}
                                <Form.Group >
                                    <Form.Label>Fotografia</Form.Label>
                                    <div style={{
                                        width: '51.8%',
                                        aspectRatio: '3/4',
                                        border: '1px dashed #ccc',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0 auto',
                                        overflow: 'hidden',
                                        position: 'relative'
                                    }}>
                                        {/* Input de archivo con referencia */}
                                        <Form.Control
                                            type="file"
                                            accept="image/*"
                                            style={{ display: 'none' }}
                                        />

                                        {/* Área de subida */}
                                        <label
                                            htmlFor="formFoto"
                                            style={{
                                                cursor: 'pointer',
                                                width: '100%',
                                                height: '100%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            
                                        </label>

                                        
               
                                    </div>
                                </Form.Group>
                                <Form.Group >
                                    <Form.Label>
                                        Nombre
                                    </Form.Label>
                                    {
                                        cargando ?
                                            <Skeleton/>
                                       :
                                            <Form.Control/>
                                     }
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label>
                                        Apellidos
                                    </Form.Label>
                                    {
                                        cargando ?
                                            <Skeleton/>
                                       :
                                            <Form.Control/>
                                     }
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group >
                                    <Form.Label>Tipo Usuario</Form.Label>
                                    {
                                        cargando ?
                                            <Skeleton/>
                                       :
                                            <Form.Control/>
                                     }
                                </Form.Group>

                                <Form.Group >
                                    <Form.Label>
                                        Categoria
                                    </Form.Label>
                                    {
                                        cargando ?
                                            <Skeleton/>
                                       :
                                            <Form.Control/>
                                     }
                                </Form.Group>

                                <Form.Group >
                                    <Form.Label>
                                        Estatus
                                    </Form.Label>
                                    {
                                        cargando ?
                                            <Skeleton/>
                                       :
                                            <Form.Control/>
                                     }
                                </Form.Group>

                                <Form.Group >
                                    <Form.Label>
                                        C.U.R.P
                                    </Form.Label>
                                     {
                                        cargando ?
                                            <Skeleton/>
                                       :
                                            <Form.Control/>
                                     }
                                </Form.Group>

                                <Form.Group >
                                    <Form.Label>Fecha de Nacimiento</Form.Label>
                                     {
                                        cargando ?
                                            <Skeleton/>
                                       :
                                            <Form.Control/>
                                     }
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Usuario</Form.Label> &nbsp;

                                     {
                                        cargando ?
                                            <Skeleton/>
                                       :
                                            <Form.Control/>
                                     }
                                </Form.Group>

                                <Form.Group className="mt-3">
                                    <Form.Label>Contrase&ntilde;a</Form.Label> &nbsp;
                                    {
                                        cargando ?
                                            <Skeleton/>
                                       :
                                            <Form.Control/>
                                     }

                                        <Form.Control />
                                </Form.Group>
                                <Form.Group >
                                    <Form.Label>
                                        Domicilio Personal
                                    </Form.Label>
                                     {
                                        cargando ?
                                            <Skeleton/>
                                       :
                                            <Form.Control/>
                                     }
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <Card className="mt-3">
                    <Card.Body>
                        <Row >
                            <h5>
                                Operatividad
                            </h5>
                            <Col md={6} className="mt-2">
                                <Form.Group >
                                    <Form.Label>Telefono de trabajo</Form.Label>
                                    {
                                        cargando ?
                                            <Skeleton/>
                                       :
                                            <Form.Control/>
                                     }
                                </Form.Group>
                                <Form.Group >
                                    <Form.Label>Datos de contacto personal</Form.Label>
                                    {
                                        cargando ?
                                            <Skeleton/>
                                       :
                                            <Form.Control/>
                                     }
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group >
                                    <Form.Label>Email de trabajo</Form.Label>
                                    {
                                        cargando ?
                                            <Skeleton/>
                                       :
                                            <Form.Control/>
                                     }
                                </Form.Group>

                                <Form.Group >
                                    <Form.Label>Fecha de Ingreso</Form.Label>
                                    {
                                        cargando ?
                                            <Skeleton/>
                                       :
                                            <Form.Control/>
                                     }
                                </Form.Group>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                        </>
                        :

                        <EditarUsuario
                        empleado={empleado}
                        />
            }
        </>
 );
};

export default DetalleEmpleado;